module.exports = __webpack_public_path__ + "static/img/rareTitle.b4fe99ea.png";